import React, { FC, ReactNode } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { Theme } from "../../Theme";

const MessageContainer = styled.div`
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.grey.toString()};
    border-radius: 4px;
`;

const MessageHeader = styled.div`
    padding: 10px 20px;
    font-weight: 700;
    color: white;
    background-color: ${({ theme }) => theme.colors.red.toString()};
`;

const MessageBody = styled.div`
    padding: 20px;
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

export type MessageProps = {
    header?: ReactNode;
    color?: keyof Theme["colors"];
};

const Message: FC<MessageProps> = ({ header, children, color }) => {
    const theme = useTheme();
    const backgroundColor =
        color && theme.colors[color]
            ? theme.colors[color].toString()
            : theme.colors.red.lighten(1.1).toString();

    const containerStyles = css`
        background-color: ${backgroundColor};
    `;

    return (
        <MessageContainer css={containerStyles}>
            {header && <MessageHeader>{header}</MessageHeader>}
            <MessageBody>{children}</MessageBody>
        </MessageContainer>
    );
};

export default Message;
